"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { useSnapshot } from "valtio";
import { useAccount } from "wagmi";
import { isWagmiAccount } from "../../lib/wagmi/helpers";
import { AccountActions, AccountState } from "../accountStore";
export function useSyncAccountStoreWithWagmiAccount(t0) {
  const $ = _c(6);
  const {
    siweAdapter
  } = t0;
  const {
    chainArch,
    shouldSyncAccountState
  } = useSnapshot(AccountState);
  const account = useAccount();
  const isWagmiHydrated = useRef(account.isConnecting);
  let t1;
  let t2;
  if ($[0] !== account || $[1] !== chainArch || $[2] !== shouldSyncAccountState || $[3] !== siweAdapter) {
    t1 = function syncAccountStoreWithWagmiAccount() {
      if (account.isConnecting) {
        isWagmiHydrated.current = true;
      }
      if (!isWagmiHydrated.current) {
        return;
      }
      if (chainArch !== "EVM") {
        return;
      }
      if (account.isConnecting) {
        AccountActions.setIsConnecting(true);
        return;
      }
      let accountInput;
      if (isWagmiAccount(account)) {
        accountInput = {
          address: account.address,
          chainId: account.chainId,
          connectorId: account.connector.id,
          addresses: account.addresses ?? [],
          ...(siweAdapter ? {} : {
            ready: true
          })
        };
      } else {
        accountInput = undefined;
      }
      AccountActions.setExternalAccount(accountInput && account.address ? {
        ...accountInput,
        address: account.address
      } : undefined);
      if (!shouldSyncAccountState) {
        return;
      }
      AccountActions.setAccount(accountInput);
    };
    t2 = [account, chainArch, siweAdapter, shouldSyncAccountState];
    $[0] = account;
    $[1] = chainArch;
    $[2] = shouldSyncAccountState;
    $[3] = siweAdapter;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
}